import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogStyled = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 15px;
  }
`;
